import { DISMISS_RECOMMENDATION_SUCCESS } from './actionTypes';

export const dismissRecommendationSuccess = recommendation => ({
    type: DISMISS_RECOMMENDATION_SUCCESS,
    payload: recommendation,
});
